import { PrivateNizzaAccount, useAccount } from '@nizza/core';
import { useAtom } from 'jotai';
import { useEffect, useMemo } from 'react';
import baseLogger from '~logger';
import { adminNameAtom } from '../state';

const logger = baseLogger.child('useAdminName');

const useAdminName = () => {
  const { account } = useAccount<PrivateNizzaAccount>();
  const [adminName, setAdminName] = useAtom(adminNameAtom);

  const adminNameWithSuffix = useMemo(
    () => String(adminName) + '_admin',
    [adminName],
  );

  useEffect(() => {
    if (!account?.username) {
      logger.debug('Account username is not defined');
      return;
    }
    setAdminName(account.username);
  }, [account, setAdminName]);

  const changeAdminName = (newAdminName: string) =>
    setAdminName(() => newAdminName);

  return {
    adminName,
    changeAdminName,
    adminNameWithSuffix,
  };
};

export default useAdminName;
